module.exports = __webpack_public_path__ + "static/media/Z6.c76267aa.jpg";